// ViewEditDeleteTrainings.js

import React, { useState, useEffect } from 'react';
import { Button, Form, Tab, Tabs } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.css';
import AttachmentsTab from './AttachmentsTab';
import { isAuthenticated, getUser } from '../utils/auth';
import Swal from 'sweetalert2';

function ViewEditDeleteTrainings() {
  const navigate = useNavigate();
  const { id } = useParams();

  const loggedInUser = getUser();
  console.log ("loggedinuser ", loggedInUser);
  // Base API URL from environment variable
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [training, setTraining] = useState({
    id: null, // Initialize id explicitly
    referenceCode: '',
    title: '',
    description: '',
    dateRange: [new Date(), new Date()],
    startTime: '',
    endTime: '',
    location: '',
    max_seat: 10,
    status: 'Draft',
    assignedTrainer: '',
    assignedTrainerId: '',
    cancelReason: '',
    prerequisites: []
  });

  const [key, setKey] = useState('details');
  const [isEditing, setIsEditing] = useState(false);
  const [trainers, setTrainers] = useState([]);
  const [requiredDuration, setRequiredDuration] = useState(null); // Course's required hours, for display only — course never changes on edit

  useEffect(() => {
    fetch(`${API_BASE_URL}/users/get_users.php?status=active`, { credentials: 'include' })
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data)) {
          // A trainingadmin may personally act as a trainer for their own
          // vendor — get_users.php already scopes a trainingadmin session's
          // result to just their own vendor company, so including
          // trainingadmin rows here can't pull in another vendor's admins.
          // Other roles (admin/masteradmin/companyadmin/departmentadmin)
          // keep seeing trainer-only, matching the previous behavior.
          setTrainers(data.filter(u => u.role === 'trainer' || (loggedInUser.role === 'trainingadmin' && u.role === 'trainingadmin')));
        } else {
          setTrainers([]);
        }
      })
      .catch(error => console.error('Error fetching trainers:', error));
  }, []);

  useEffect(() => {
    // Fetch the training details based on the ID
    // For example, fetch from the backend and set the state
    // This is a placeholder for actual data fetching
    
    // const fetchTrainingDetails = async () => {
    //  const fetchedTraining = {
    //    referenceCode: 'T123',
    //    title: 'Course 1',
    //    description: 'Description of Course 1',
    //    dateRange: [new Date(), new Date()],
    //    time: '10:00',
    //    location: 'Room 101',
    //    status: 'Scheduled',
    //    assignedTrainer: 'John Doe',
    //    cancelReason: ''
    //  };
    //  setTraining(fetchedTraining);
    // };
    // fetchTrainingDetails();


    if (id) {
      // If the ID exists, fetch the training details for editing
      setIsEditing(true);
      fetch(`${API_BASE_URL}/trainings/get_training.php?id=${id}`, { credentials: 'include' })
        .then(response => response.json())
        .then(data => {
          console.log("data",data);
          setTraining ({
            id: data.id,
            referenceCode: data.code,
            title: data.title,
            description: data.description,
            dateRange: data.dateRange,
            startTime: data.startTime || '',
            endTime: data.endTime || '',
            location: data.location,
            max_seat: data.max_seat,
            assignedTrainer: data.assignedTrainer,
            assignedTrainerId: data.assignedTrainerId || '',
            cancelReason: data.cancelReason,
            status: data.status,
            prerequisites: data.prerequisites || []
          });
          setRequiredDuration(data.courseDuration ?? null);
          //setTraining(fetchedTraining);
        })
        .catch(error => console.error('Error fetching training:', error));
    }


  }, [id]);

  const handleChange = e => {
    const { name, value } = e.target;
    setTraining(prevTraining => ({
      ...prevTraining,
      [name]: value
    }));
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setTraining(prevTraining => ({
      ...prevTraining,
      dateRange: [start, end]
    }));
  };

  const handleSave = () => {
    console.log("saving training info ", training);
    const formData = new FormData();
    Object.keys(training).forEach(key => {
      // Format dateRange as start and end dates
      if (key === 'dateRange') {
        console.log("daterange",training.dateRange);
        let [startDate, endDate] = training.dateRange;

        // Convert to Date objects if they are not already
        startDate = new Date(startDate);
        endDate = new Date(endDate);
        
        console.log("startDate",startDate);
        console.log("startDate",startDate.toLocaleDateString('en-CA'));
        console.log("startDate",endDate.toLocaleDateString('en-CA'));

        formData.append('startDate', startDate.toLocaleDateString('en-CA')); // Format as YYYY-MM-DD
        formData.append('endDate', endDate.toLocaleDateString('en-CA')); // Format as YYYY-MM-DD
        formData.append(key, training[key]);
      } else {
        formData.append(key, training[key]);
      }
    });
    formData.append('isUpdate',isEditing);
  
    console.log("formdata",formData);

    fetch(`${API_BASE_URL}/trainings/save_training.php`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    })
    .then(response => {
      const contentType = response.headers.get('content-type');
  
      // Log the status and response text for debugging
      console.log('Response Status:', response.status);
      
      // Attempt to read the response as text first
      return response.text().then((text) => {
        console.log('Raw Response:', text); // Log the raw response text
        
        if (!response.ok) {
          // If response is not ok, throw an error with the response text
          throw new Error(`Failed with status ${response.status}: ${text}`);
        }
  
        // If response is JSON, parse it
        if (contentType && contentType.includes('application/json')) {
          return JSON.parse(text); // Parse JSON manually
        } else {
          // Return the raw text if it's not JSON
          return text;
        }
      });
    })
    .then(data => {
      console.log("data",data);
      // Check if the response is JSON or plain text
      if (typeof data === 'string') {
        console.log('Non-JSON response:', data);
        Swal.fire({ icon: 'error', text: `Received non-JSON response: ${data}` });
      } else if (data.success) {
        navigate('/trainings');
      } else {
        console.error('PHP Error:', data.message || data.error); // Log PHP error to the console
        Swal.fire({ icon: 'error', text: `Failed to save training: ${data.message || data.error}` });
      }
    })
    .catch(error => {
      console.error('Error saving training:', error);
      Swal.fire({ icon: 'error', text: `Error: ${error.message}` });
    });
  };

  const handleCancel = () => {
    // Redirect back to the training provider dashboard without saving
    navigate('/trainings');
  };

  const handleDelete = async () => {
    // Add logic to handle deleting training data
    console.log('Training deleted:', id);
    const result = await Swal.fire({
      icon: 'warning',
      text: 'Are you sure you want to delete this training?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });
    if (result.isConfirmed) {
      fetch(`${API_BASE_URL}/trainings/delete_training.php?id=${id}`, {
        method: 'DELETE',
        credentials: 'include',
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            //setTraining(training.filter(training => training.id !== id));
            navigate('/trainings');
          } else {
            Swal.fire({ icon: 'error', text: 'Failed to delete training' });
          }
        })
        .catch(error => console.error('Error deleting training:', error));
    }
  };

  return (
    <div>
      <h2>Edit/Delete Training</h2>
      <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
        <Tab eventKey="details" title="Training Details">
          <Form>
            <Form.Group controlId="referenceCode">
              <Form.Label>Course/Training Reference Code</Form.Label>
              <Form.Control type="text" name="referenceCode" value={training.referenceCode} onChange={handleChange} readOnly/>
            </Form.Group>
            <Form.Group controlId="title" className="mt-2">
              <Form.Label>Title</Form.Label>
              <Form.Control type="text" name="title" value={training.title} onChange={handleChange} readOnly />
            </Form.Group>
            <Form.Group controlId="description" className="mt-2">
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" rows={3} name="description" value={training.description} onChange={handleChange} readOnly />
            </Form.Group>
            <Form.Group controlId="prerequisites" className="mt-2">
              <Form.Label>Prerequisite Course(s)</Form.Label>
              <Form.Control
                type="text"
                value={training.prerequisites.length > 0
                  ? training.prerequisites.map(p => `${p.code} — ${p.title}`).join(', ')
                  : 'None'}
                readOnly
              />
            </Form.Group>
            {requiredDuration !== null && (
              <Form.Text className="d-block mt-2">
                This course requires at least {requiredDuration} hour(s) of training. The date range and daily time window below must cover at least that much.
              </Form.Text>
            )}
            <Form.Group controlId="dateRange" className="mt-2">
              <Form.Label>Date</Form.Label>
              <DatePicker
               dateFormat="dd/MM/yyyy"
                onChange={handleDateChange}
                startDate={training.dateRange[0]}
                endDate={training.dateRange[1]}
                selectsRange
                
              />
            </Form.Group>
            <Form.Group controlId="timeRange" className="mt-2">
              <Form.Label>Time </Form.Label>
              <div style={{ display: 'flex', gap: '10px' }}>
                <Form.Control
                  type="time"
                  name="startTime"
                  value={training.startTime}
                  onChange={handleChange}
                  style={{ width: '130px' }}
                />
                <span>to</span>
                <Form.Control
                  type="time"
                  name="endTime"
                  value={training.endTime}
                  onChange={handleChange}
                  style={{ width: '130px' }}
                />
              </div>
            </Form.Group>
            <Form.Group controlId="location" className="mt-2">
              <Form.Label>Location</Form.Label>
              <Form.Control type="text" name="location" value={training.location} onChange={handleChange} />
            </Form.Group>
            <Form.Group controlId="max_seat" className="mt-2">
              <Form.Label>Maximum Seat</Form.Label>
              <Form.Control type="text" name="max_seat" value={training.max_seat} onChange={handleChange} />
            </Form.Group>
            <Form.Group controlId="status" className="mt-2">
              <Form.Label>Status</Form.Label>
              <Form.Control as="select" name="status" value={training.status} onChange={handleChange}>
                <option value="Scheduled">Draft</option>
                <option value="Scheduled">Scheduled</option>
                <option value="Canceled">Canceled</option>
                <option value="Postponed">Postponed</option>
                <option value="Completed">Completed</option>
              </Form.Control>
            </Form.Group>

            {(training.status === 'Canceled' || training.status === 'Postponed') && (
              <Form.Group controlId="cancelReason" className="mt-2">
                <Form.Label>{training.status === 'Postponed' ? 'Postpone Reason' : 'Cancel Reason'}</Form.Label>
                <Form.Control as="textarea" rows={3} name="cancelReason" value={training.cancelReason} onChange={handleChange} required />
              </Form.Group>
            )}
            <Form.Group controlId="assignedTrainerId" className="mt-2">
              <Form.Label>Assigned Trainer</Form.Label>
              <Form.Control
                as="select"
                name="assignedTrainerId"
                value={training.assignedTrainerId}
                onChange={e => {
                  const selectedTrainer = trainers.find(t => String(t.id) === e.target.value);
                  setTraining(prevTraining => ({
                    ...prevTraining,
                    assignedTrainerId: e.target.value,
                    assignedTrainer: selectedTrainer ? selectedTrainer.name : ''
                  }));
                }}
              >
                <option value="">Select Trainer</option>
                {trainers.map(trainer => (
                  <option key={trainer.id} value={trainer.id}>
                    {trainer.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form>
          <div className="mt-3">
            <Button variant="primary" className="mr-2" onClick={handleSave}>Save</Button>
            <Button variant="secondary" className="mr-2" onClick={handleCancel}>Return</Button>
            <Button variant="danger" onClick={handleDelete}>Delete</Button>
          </div>
        </Tab>
        <Tab eventKey="documents" title="Documents/Attachment">
          {training.id !== null && (
          <AttachmentsTab 
            categoryId={training.id} 
            category="training_documents" 
            currentUserId={loggedInUser.id}
          />
        )}
        </Tab>
      </Tabs>

    </div>
  );
}

export default ViewEditDeleteTrainings;
